import * as React from 'react';
import { Overlay, SideModal, SideModalContent } from '~/common/layout/Modals';
import Head from '~/common/layout/Head';

export default (props) => {
  const { headTitle, onClose, onDelete, user } = props;

  const handleClose = (e) => {
    e.preventDefault();
    onClose();
  };

  const handleDelete = (e) => {
    e.preventDefault();
    onDelete(user);
  };

  return (
    <Overlay onClick={onClose}>
      <SideModal>
        <Head headTitle={headTitle} />

        <SideModalContent>
          <div className="confirmation__send">
            <h3 className="confirmation__send__heading">Are you sure you want to delete "{user.username}"?</h3>
            <div className="confirmation__send__buttons">
              <button className="btn btn--prim btn--lg btn--white" type="button" onClick={handleDelete}>YES</button>
              <button className="btn btn--prim btn--lg btn--white" type="button" onClick={handleClose}>NO</button>
            </div>
          </div>
        </SideModalContent>
      </SideModal>
    </Overlay>
  );
};
